import React from "react";
import "./styles.scss";
import PropTypes from "prop-types";

const Wrapper = ({children, fade, fadeOut, colonneFormSlide, onCLick}) => {
    return (
        <div id="wrapper" className={`${fade} ${fadeOut} ${colonneFormSlide}`} onClick={onCLick}>
            {children}
        </div>
    );
};

Wrapper.propTypes = {
    children: PropTypes.node,
    fade: PropTypes.string,
    fadeOut: PropTypes.string,
    colonneFormSlide: PropTypes.string,
    onCLick: PropTypes.func,
};

export default Wrapper;
